<template>
  <div>
    <v-app-bar
      class="white"
      app
    >
      <router-link to="/">
        <img
          src="@/assets/sunnycloud_transparent_web.png"
          alt="Sunnycloud CRM"
          height="60"
        >
      </router-link>
      <v-spacer />
      <v-btn
        v-for="route in internallinks"
        :key="route.link"
        :to="route.link"
        text
      >
        {{ route.text }}
      </v-btn>
      <v-btn
        text
        href="https://app.sunnycloud.se/Signup"
      >
        Skapa konto
      </v-btn>
      <v-btn
        text
        href="https://app.sunnycloud.se/Login"
      >
        Logga in
      </v-btn>
    </v-app-bar>
    <router-view />
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  data() {
    return {
      internallinks: [
        {
          link: '/sv/crm/pris',
          text: 'Pris',
        },
        {
          link: '/sv/demo',
          text: 'Demo',
        },
      ],
    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  },
}
</script>

<style lang='scss' scoped>
  .v-btn {
    margin-left: 5px;
  }
</style>
